module.exports = __webpack_public_path__ + "static/img/KIA.d6a390f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos_vehicules/KIA.png
// module id = aSVA
// module chunks = 1